"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Subtitle = exports.AnnouncementPageTitle = exports.Content = exports.StyledButton = exports.AnnouncementColumn = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _styledSystem = require("styled-system");

var _Button = _interopRequireDefault(require("../Button"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var _Typography = require("../Typography");

var Wrapper = (0, _styled.default)(_rebass.Flex)(function (_ref) {
  var _ref$theme = _ref.theme,
      space = _ref$theme.space,
      colors = _ref$theme.colors,
      announcements = _ref$theme.announcements;
  return (0, _styledSystem.variant)({
    variants: {
      primary: {
        width: '100%',
        padding: "".concat(space.large, " 0"),
        background: colors[announcements.background],
        p: {
          marginBottom: 0
        }
      },
      secondary: {
        width: '100%',
        padding: ["".concat(space.medium, " 0"), null, "".concat(space.base, " 0")],
        background: colors[announcements.backgroundSecondary],
        p: {
          marginBottom: 0
        }
      }
    }
  });
});
exports.Wrapper = Wrapper;
var AnnouncementColumn = (0, _styled.default)('div')(_defineProperty({}, _mediaQueries.default.medium, {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
}));
exports.AnnouncementColumn = AnnouncementColumn;
var StyledButton = (0, _styled.default)(_Button.default)(function (_ref3) {
  var _ref4;

  var space = _ref3.theme.space;
  return _ref4 = {
    marginTop: space.base,
    flexBasis: 'fit-content',
    width: '100%'
  }, _defineProperty(_ref4, _mediaQueries.default.small, {
    width: 'auto'
  }), _defineProperty(_ref4, _mediaQueries.default.medium, {
    marginLeft: space.large,
    marginTop: '0'
  }), _ref4;
});
exports.StyledButton = StyledButton;
var Content = (0, _styled.default)(_rebass.Box)();
exports.Content = Content;
var AnnouncementPageTitle = (0, _styled.default)(_Typography.PageTitle)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      announcements = _ref5$theme.announcements;
  return {
    color: colors[announcements.foreground]
  };
});
exports.AnnouncementPageTitle = AnnouncementPageTitle;
var Subtitle = (0, _styled.default)(_Typography.Body)(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      announcements = _ref6$theme.announcements;
  return {
    color: colors[announcements.foreground],
    a: {
      color: colors[announcements.subtitleLinkColor],
      '&:hover': {
        color: colors[announcements.subtitleLinkColorHover]
      }
    }
  };
});
exports.Subtitle = Subtitle;